module.exports = __webpack_public_path__ + "img/aguardando-sempedidos.a3b489b0.png";